import * as React from "react";
import {
  IconReactionMustHugNoBg,
  IconReactionNahNoBg,
  IconReactionYayNoBg,
  IconReactionMehNoBg,
} from "atoms";
import { useProject } from "features/reviewable/api/useProject";
import { ReviewStats } from "./ReviewStats";

interface Props {
  projectId: string;
}

function ProjectReviewStats({ projectId, ...props }: Props) {
  const { data: project } = useProject(projectId);

  const { ratings, total } = React.useMemo(() => {
    const aggregateRatings = {
      "Must Hug": {
        value: project?.counterMustHug ?? 0,
        icon: <IconReactionMustHugNoBg />,
      },
      Yay: {
        value: project?.counterYay ?? 0,
        icon: <IconReactionYayNoBg />,
      },
      Meh: {
        value: project?.counterMeh ?? 0,
        icon: <IconReactionMehNoBg />,
      },
      Nah: {
        value: project?.counterNah ?? 0,
        icon: <IconReactionNahNoBg />,
      },
    } as const;

    return {
      ratings: aggregateRatings,
      total: Object.values(aggregateRatings).reduce(
        (sum, { value }) => sum + value,
        0
      ),
    };
  }, [project]);

  return (
    <ReviewStats type="PROJECT" max={total} ratings={ratings} {...props} />
  );
}

export { ProjectReviewStats };
